export default "__VITE_ASSET__D$XzhuQE__"